import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import IncomeDetails from "../IncomeDetails";
import EducationDetails from "../Education";
import TabSection from "../IdfcLetterHead/TabSection";
import PersonalDetails from "../PersonalInfo/PersonalDetails";
import BtnSet from "./BtnSet";
import "../ApplicationForm/applicationform.scss";
import "./disburse.scss";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../Services";
import AppViewTab from "../modules/AppViewTab";

import FooterText from "../modules/FooterText";
import { GetBaseUrl } from "../modules/getBaseUrl";
import BankDetails from "./BankDetails";
import SPOCDetails from "./SPOCDetails";
// import {CombineData}  from "./DataComposition";

function DisburseForm() {
  const [tabs, setTabs] = useState({ personal: 0, income: 0, education: 0 });
  const [err, setErr] = useState({
    personal: false,
    income: false,
    education: false,
  });
  const info = useSelector((state) => state.personal.personalInfo);
  const eduInfo = useSelector((state) => state.education.eduInfo);
  const tokenData = useSelector((state) => state.tokens.tokens);

  const [Link, setLink] = useState("");

  useEffect(() => {
    let url = window.location.href;
    let baseUrl = GetBaseUrl(url);

    const cleanedUrl = url.replace(/^https?:\/\/(www\.)?/, "");
    setLink(cleanedUrl);
  }, []);
  console.log("in form", eduInfo);
  return (
    <div className="form-div disburse-form">
      {!tokenData?.totalLoginResponse?.collegeBankDetailsUpdated && (
        <AppViewTab
          heading1={"Scholarship Disbursement Form"}
          heading2={`Hello ${info.firstName}! Please enter the bank account details of your college, for us to set up the scholarship payment process, for you.`}
          tabs={tabs}
          tabList={[
            { title: "Bank Account details", phase: "bank" },
            { title: "SPOC Details", phase: "spoc" },
          ]}
        />
      )}
      {/* {eduInfo?.campusSpecific === "Others" && ( */}
      <Routes>
        <Route
          path="/"
          element={
            !tokenData?.totalLoginResponse?.collegeBankDetailsUpdated ? (
              <BankDetails
              // setErr={(e) => setErr({ ...err, personal: e })}
              // onChange={(e) => setTabs({ ...tabs, personal: e })}
              />
            ) : (
              <SPOCDetails
                others={eduInfo?.campusSpecific === "Others"}
              />
            )
          }
        />
        <Route
          path="/*"
          element={
            <BankDetails
            // setErr={(e) => setErr({ ...err, personal: e })}
            // onChange={(e) => setTabs({ ...tabs, personal: e })}
            />
          }
        />
        <Route
          path="/bank"
          element={
            <BankDetails
            // setErr={(e) => setErr({ ...err, personal: e })}
            // onChange={(e) => setTabs({ ...tabs, personal: e })}
            />
          }
        />
        <Route
          path="/spoc"
          element={
            <SPOCDetails
              others={eduInfo?.campusSpecific === "Others"}
              // setErr={(e) => setErr({ ...err, personal: e })}
              // onChange={(e) => setTabs({ ...tabs, personal: e })}
            />
          }
        />
      </Routes>
      <BtnSet
        errList={err}
        // isSubmit={Link.split("/")[3] === "education"}
        // disabled={appData?.currentPage === "education"}
      />
      <FooterText />
    </div>
  );
}

export default DisburseForm;
